export const MARGIN = 6
export const MOBILE_WIDTH = '85vw'
export const bg = 'gray.100'
export const bgSelected = 'gray.200'
export const bgSelectedHover = 'gray.100'
export const bgActive = 'gray.100'
